import styled from "styled-components/macro";
import { media } from "../../../../utils";

export const SelectTitle = styled.p`
  font-size: 14px;
  color: #424242;
`;

export const ButtonCondicoesGerais = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 255px;
  padding: 0;
  height: 51px;
  ${media.md()} {
    max-width: 246px;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
`;

export const FormContent = styled.div({
  [media.lg()]: {
    display: "flex",
    ".FormControl": {
      marginRight: "32px",
    },
  },
});

export const Container = styled.div({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  [media.lg()]: {
    justifyContent: "flex-start",
  },
});

export default ButtonCondicoesGerais;
